module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0143.jpg?v=68a24c37";